var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrakLogoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260.942,
    height: 49.113,
    viewBox: "0 0 260.942 49.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.544,
    y1: 1.386,
    x2: 0.478,
    y2: -0.404,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.595,
    y1: 0.985,
    x2: 0.405,
    y2: 0.015,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trak_Global_Logo_-_Full_Colour_-_Black",
    "data-name": "Trak Global Logo - Full Colour - Black",
    transform: "translate(-22.919 -19.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M98.936,31.274H93.78V28.485h13.38v2.789H102V44.755H98.936ZM128.9,44.755H125.25l-4.735-5.435h-2.957v5.435H114.49V28.46h7.735c3.834,0,5.9,2.578,5.9,5.392a4.828,4.828,0,0,1-4.145,5.173l4.921,5.552ZM117.557,31.342v5.207h4.668a2.612,2.612,0,1,0,0-5.207Zm53.924-2.764-7.221,7.785,7.827,8.2v.185H168.3l-6.808-7.2v7.2H158.43V28.485h3.058v6.875l6.184-6.875h3.808Zm-26.962-.093h-3.37l-7.288,16.261h3.32L142.825,31.9l5.62,12.849h3.37ZM143.508,40.2l-.379-1.407h-.573l-.379,1.407-.666,2.46h2.662Z",
    transform: "translate(-11.156 -1.387)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M66.421,32.844l-.118-.918-.741-.565a89.017,89.017,0,0,0-9.487-6.294A88.956,88.956,0,0,0,45.88,20.012l-.843-.362-.843.362A92.151,92.151,0,0,0,24.479,31.362l-.733.565-.118.918a91.62,91.62,0,0,0,0,22.749l.118.918.741.565a90.323,90.323,0,0,0,9.454,6.277,91.838,91.838,0,0,0,10.195,5.055l.843.354.843-.354a91.085,91.085,0,0,0,10.195-5.055,90.058,90.058,0,0,0,9.555-6.336l.733-.556.118-.927a89.95,89.95,0,0,0,.708-11.358,90.473,90.473,0,0,0-.708-11.332ZM62.149,54.094a87.056,87.056,0,0,1-8.282,5.451A86.068,86.068,0,0,1,45.02,64a86.786,86.786,0,0,1-8.838-4.457,85.866,85.866,0,0,1-8.274-5.426,86.783,86.783,0,0,1,0-19.766,85.941,85.941,0,0,1,17.121-9.909,86.784,86.784,0,0,1,8.838,4.449,85.943,85.943,0,0,1,8.274,5.435,85.175,85.175,0,0,1,.565,9.883A86.865,86.865,0,0,1,62.149,54.094ZM57.313,36.981a1.972,1.972,0,0,1-3.227,1.5l-4.213,2.848a5.67,5.67,0,0,1,.666,2.662,5.569,5.569,0,0,1-.43,2.157l3.025,1.112a1.963,1.963,0,1,1-.421,1.2v-.084l-3.185-1.154a5.637,5.637,0,0,1-4.061,2.427v7.069a1.98,1.98,0,1,1-1.2,0V49.654a5.637,5.637,0,0,1-3.488-1.685l-3.707,2.149a1.786,1.786,0,0,1,0,.371,1.98,1.98,0,1,1-1.98-1.972,1.955,1.955,0,0,1,1.356.547l3.547-2.047a5.654,5.654,0,0,1,.539-6.673L36.586,36.13a2.064,2.064,0,0,1-.843.194,1.98,1.98,0,1,1,1.98-1.972,1.946,1.946,0,0,1-.261.952l3.952,4.213a5.67,5.67,0,0,1,3.033-1.129v-.539a1.98,1.98,0,1,1,1.2.051v.539a5.654,5.654,0,0,1,3.513,1.946l4.213-2.865a1.972,1.972,0,1,1,3.876-.506Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M241.746,30.175c.918.421,1.845.893,2.747,1.415a28.527,28.527,0,0,1,2.6,1.685c.1,1.011.152,2.047.152,3.084s-.051,2.073-.152,3.084c-.843.6-1.685,1.154-2.6,1.685a30.379,30.379,0,0,1-2.755,1.416c-.918-.421-1.845-.893-2.747-1.416a28.522,28.522,0,0,1-2.6-1.685c-.1-1.011-.152-2.047-.152-3.084s.051-2.073.152-3.084c.843-.6,1.685-1.154,2.6-1.685a29.368,29.368,0,0,1,2.755-1.416m0-3.025-.32.135a33.6,33.6,0,0,0-3.825,1.9,36,36,0,0,0-3.547,2.359l-.278.211V32.1a33.7,33.7,0,0,0,0,8.51v.345l.278.211a34.539,34.539,0,0,0,3.547,2.359,34.931,34.931,0,0,0,3.817,1.9l.32.135.32-.135a33.6,33.6,0,0,0,3.825-1.9,33.226,33.226,0,0,0,3.547-2.359l.278-.211.042-.345a33.7,33.7,0,0,0,0-8.51l-.042-.345-.278-.211a34.547,34.547,0,0,0-3.547-2.359,34.932,34.932,0,0,0-3.817-1.9l-.32-.135ZM207.2,32.3a6.168,6.168,0,0,0-4.095-1.609c-3.454,0-5.552,2.629-5.552,5.9,0,2.646,1.542,5.384,5.552,5.384a5.308,5.308,0,0,0,3.623-1.247V37.876h-4.12V35.154h6.909v6.791a8.021,8.021,0,0,1-6.42,2.9c-6.058,0-8.518-3.977-8.518-8.215-.025-4.55,2.806-8.763,8.493-8.763a8.527,8.527,0,0,1,5.982,2.469Zm12.461-3.935v13.3h8.282v2.814H216.588V28.363ZM270,33.039a3.286,3.286,0,0,1-2.1,3.109,3.926,3.926,0,0,1,2.578,3.589c0,3.589-2.7,4.744-6.033,4.744H256.8V28.363h7.642c3.143,0,5.519,1.432,5.519,4.676Zm-10.2,1.795h4.651c1.913,0,2.528-.843,2.528-1.727,0-.733-.6-1.98-2.528-1.98h-4.651Zm0,6.816h4.651c1.247,0,3.016-.413,3.016-1.938s-1.769-2.208-3.016-2.208h-4.651Zm28.874-.211h-8.426l-1.382,3.042h-3.294L282.8,28.363h3.32l7.229,16.118h-3.32Zm-4.213-9.689-2.991,6.858h5.982ZM302.6,28.38V41.667h8.282v2.814H299.529V28.363Z",
    transform: "translate(-27.026 -1.181)",
    fill: "#3a3b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M101.676,66.474a4.255,4.255,0,0,1-3.1,1.222,4.044,4.044,0,0,1-4.356-4.213,4.331,4.331,0,0,1,7.4-3.1l-.843.843a3.025,3.025,0,0,0-2.132-.843,2.9,2.9,0,0,0-3.05,3.067,2.856,2.856,0,0,0,3.05,3.008,3.168,3.168,0,0,0,2.191-.893Z",
    transform: "translate(-11.225 -6.212)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M115.065,63.44a4.213,4.213,0,1,1-8.426,0,4.137,4.137,0,0,1,4.213-4.331,4.053,4.053,0,0,1,4.213,4.331ZM110.852,66.5a2.772,2.772,0,0,0,2.915-3.033,2.89,2.89,0,0,0-2.89-3.143,3.088,3.088,0,0,0-.042,6.176Z",
    transform: "translate(-13.18 -6.212)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M126.994,65.178v-5.9h1.323v8.266h-1l-4.685-5.831v5.831h-1.34V59.3h1.019Z",
    transform: "translate(-15.488 -6.239)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M140.581,65.178v-5.9H141.9v8.266h-1.028l-4.685-5.831v5.831H134.86V59.3h1.011Z",
    transform: "translate(-17.624 -6.239)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M154.58,67.566h-6.1V59.3h6.066v1.289H149.8v2.233h4.558v1.222H149.8v2.224h4.777Z",
    transform: "translate(-19.768 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M167.294,66.482a4.255,4.255,0,0,1-3.109,1.222,4.044,4.044,0,0,1-4.356-4.213,4.331,4.331,0,0,1,7.372-3.084l-.885.843a3.025,3.025,0,0,0-2.132-.843,2.9,2.9,0,0,0-3.05,3.067,2.848,2.848,0,0,0,3.05,2.991,3.176,3.176,0,0,0,2.191-.893Z",
    transform: "translate(-21.555 -6.22)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M174.8,60.5H172.09V59.3h6.74v1.2h-2.7v7.069h-1.331Z",
    transform: "translate(-23.486 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M184.36,67.566V59.3h1.314v8.266Z",
    transform: "translate(-25.417 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M196.934,65.178v-5.9h1.323v8.266h-1l-4.685-5.831v5.831h-1.34V59.3h1.02Z",
    transform: "translate(-26.499 -6.239)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M210.768,61.217a3.37,3.37,0,0,0-2.233-.843,2.941,2.941,0,0,0-3.05,3.151,2.814,2.814,0,0,0,3.05,2.974,2.957,2.957,0,0,0,2.014-.725v-1.7H208.24v-1.18h3.53v3.37a4.162,4.162,0,0,1-3.244,1.432,3.989,3.989,0,0,1-4.348-4.213,4.145,4.145,0,0,1,4.348-4.364,4.306,4.306,0,0,1,3.084,1.255Z",
    transform: "translate(-28.537 -6.213)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M231.447,61.241l-2.806,3.909h-.286l-2.772-3.909v6.336H224.26V59.32h1.533l2.73,3.867,2.713-3.867h1.533v8.257h-1.323Z",
    transform: "translate(-31.699 -6.246)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M247.475,63.44a4.213,4.213,0,0,1-8.426,0,4.137,4.137,0,0,1,4.213-4.331,4.053,4.053,0,0,1,4.213,4.331ZM243.262,66.5a2.772,2.772,0,0,0,2.907-3.033,2.89,2.89,0,0,0-2.89-3.143,3.088,3.088,0,0,0-.059,6.176Z",
    transform: "translate(-34.027 -6.212)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M257.493,59.3c1.576,0,2.814.708,2.814,2.359a1.685,1.685,0,0,1-1.146,1.643,2.039,2.039,0,0,1,1.4,1.9c0,1.8-1.424,2.359-3.067,2.359H253.71V59.3Zm-2.477,3.429h2.528c.986,0,1.483-.379,1.483-1.045s-.506-1.188-1.5-1.188H255.05Zm0,3.606h2.477c.725,0,1.753-.244,1.753-1.146s-.986-1.281-1.736-1.281h-2.528Z",
    transform: "translate(-36.336 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M266.53,67.566V59.3h1.306v8.266Z",
    transform: "translate(-38.354 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M274.673,59.3v7.035h4.356v1.23H273.35V59.3Z",
    transform: "translate(-39.428 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M284.37,67.566V59.3h1.306v8.266Z",
    transform: "translate(-41.163 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M292.9,60.5H290.19V59.3h6.74v1.2h-2.688v7.069h-1.331Z",
    transform: "translate(-42.079 -6.243)",
    fill: "#83819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M305.281,62.948l2.342-3.648h1.592v.059l-3.278,4.819v3.37h-1.323v-3.37l-3.185-4.819V59.3H303Z",
    transform: "translate(-43.849 -6.243)",
    fill: "#83819c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrakLogoLarge);
export default __webpack_public_path__ + "static/media/trak-logo-large.24c6fee43a4336596b8a31049e6d6146.svg";
export { ForwardRef as ReactComponent };